import { BRANDS_TO_FETCH } from "./constants";

const transformArrayAttributeToObject = (brands = []) => {
  return brands.map((item) => {
    const attributes = item[0];
    return {
      ...attributes
    };
  });
};

export const getBrandsFormatted = (brands = []) => {
  const formattedArray = transformArrayAttributeToObject(brands);

  const filteredBrandsByFetchedBrands = formattedArray.filter(
    (singleItem) =>
      singleItem.available &&
      BRANDS_TO_FETCH.some((item) => item.name === singleItem.name)
  );

  return filteredBrandsByFetchedBrands.map((item) => {
    const slug = item.path.substring(1);
    const savings = item.savings !== "0.00" ? item.savings : item.cashBack;
    return {
      id: item.id,
      brandName: item.name,
      savings: item.savings,
      cashBack: item.cashBack,
      info: `Up to ${savings}%`,
      image: item.src,
      linkTo: `/buy-${slug}-gift-cards`
    };
  });
};
